import './sass/main.scss';
import './js/task-1'